import { render, staticRenderFns } from "./FormCaixaItem.vue?vue&type=template&id=9c80df24&scoped=true"
import script from "./FormCaixaItem.vue?vue&type=script&lang=js"
export * from "./FormCaixaItem.vue?vue&type=script&lang=js"
import style0 from "./FormCaixaItem.vue?vue&type=style&index=0&id=9c80df24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c80df24",
  null
  
)

export default component.exports